<template>
  <div>
    <annualLeaveType-list></annualLeaveType-list>
  </div>
</template>

<script>
export default {};
</script>
